import { t } from "@auto/services";
import {
  AGE_LABELS,
  CORRECTION_GEOGRAPHY_METRICS,
  SEX_LABELS,
  STANDARD_GEOGRAPHY_METRICS,
} from "./reportingConstants.mjs";

const NUMBER_FORMAT = new Intl.NumberFormat();
const PERCENT_FORMAT = new Intl.NumberFormat(undefined, {
  minimumFractionDigits: 1,
  maximumFractionDigits: 1,
});

export const count = (value) => NUMBER_FORMAT.format(Number(value || 0));

export const percent = (value) => value === null || value === undefined
  ? "—"
  : `${PERCENT_FORMAT.format(Number(value))}%`;

export const dateTime = (value) => {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleString();
};

export const dateBucket = (value, interval = "DAY") => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);

  if (interval === "MONTH") {
    return date.toLocaleDateString(undefined, { year: "numeric", month: "short" });
  }

  return date.toLocaleDateString(undefined, {
    year: interval === "WEEK" ? "numeric" : undefined,
    month: "short",
    day: "numeric",
  });
};

export const labelOf = (row) => {
  if (!row) return "";
  const code = String(row.code || "").trim();
  const name = String(row.name || "").trim();
  if (code && name) return `${code} - ${name}`;
  return name || code || String(row.gid || t("common.unnamed"));
};

export const sexLabel = (key) => {
  const normalized = String(key || "UNKNOWN").trim().toUpperCase();
  const translationKey = SEX_LABELS[normalized];
  return translationKey ? t(translationKey) : normalized || t("common.unknown");
};

export const ageLabel = (key) => {
  const translationKey = AGE_LABELS[key];
  return translationKey ? t(translationKey) : key || t("common.unknown");
};

export const geographyMetrics = (correction) => (
  correction ? CORRECTION_GEOGRAPHY_METRICS : STANDARD_GEOGRAPHY_METRICS
);

export const metricDefinition = (metric, correction = false) => {
  const definitions = geographyMetrics(correction);
  return definitions.find((item) => item.value === metric) || definitions[0];
};

export const metricNumber = (row, metric) => {
  const value = Number(row?.[metric]);
  return Number.isFinite(value) ? value : 0;
};

export const metricDisplay = (value, metric, correction = false) => {
  const definition = metricDefinition(metric, correction);
  if (definition.kind === "percent") return percent(value);
  return count(value);
};

export const operatorDisplayName = (row) => (
  String(row?.name || row?.username || row?.nationalId || t("reporting.unknownOperator")).trim()
);
